import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState("checking");
  const { clear } = useCart();
  const { refresh } = useAuth();

  useEffect(() => {
    if (!sid) { setState("error"); return undefined; }
    let tries = 0;
    let timer;
    let alive = true;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (!alive) return;
        if (data?.payment_status === "paid") { setState("paid"); clear(); refresh(); return; }
        if (data?.status === "expired" || data?.status === "failed") { setState("error"); return; }
      } catch { /* retry */ }
      tries += 1;
      if (tries < 10) timer = setTimeout(poll, 2000); else if (alive) setState("pending");
    };
    poll();
    return () => { alive = false; clearTimeout(timer); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sid]);

  return (
    <div className="px-5 py-32 max-w-2xl mx-auto text-center" data-testid="payment-success-page">
      {state === "checking" && <><Loader2 className="mx-auto animate-spin" size={44} /><p className="f-serif text-4xl mt-6">Confirming your payment…</p></>}
      {state === "paid" && <><CheckCircle2 className="mx-auto text-[var(--red)]" size={56} /><h1 className="f-serif text-5xl mt-6" data-testid="payment-confirmed">Thank you.</h1><p className="text-lg text-[var(--ink-2)] mt-4">Your payment is confirmed. A receipt is on its way to your inbox.</p></>}
      {state === "pending" && <><p className="f-serif text-4xl">Payment still processing.</p><p className="mt-4 text-[var(--ink-2)]">We'll email you once it clears.</p></>}
      {state === "error" && <><XCircle className="mx-auto" size={48} /><p className="f-serif text-4xl mt-6">We couldn't confirm this payment.</p></>}
      <Link to="/" className="btn-ink inline-flex h-12 px-8 items-center mt-10 font-semibold" data-testid="payment-home-btn">Back to BPJ</Link>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="px-5 py-32 max-w-2xl mx-auto text-center" data-testid="payment-cancel-page">
      <p className="f-serif text-5xl">Checkout cancelled.</p>
      <p className="text-lg text-[var(--ink-2)] mt-4">No charge was made. Your bag is saved.</p>
      <div className="flex gap-3 justify-center mt-10"><Link to="/shop" className="btn-ink h-12 px-8 inline-flex items-center font-semibold">Return to store</Link><Link to="/subscribe" className="btn-line h-12 px-8 inline-flex items-center font-semibold">View plans</Link></div>
    </div>
  );
}
